import {player} from './api/entities';
import {httpGet, httpPost} from "./api/axios_api";
import Constants from "../constants/constants";

export const actions = {
    resetPlayerState: "RESET_PLAYER_STATE",
    createPlayer: "CREATE_PLAYER",
    updatePlayer: "UPDATE_PLAYER",
    listPlayer: "LIST_PLAYER",
    getPlayer: "GET_PLAYER",
    assignedPlayers: "ASSIGNED_PLAYERS",
    getMyPlayers: "GET_MY_PLAYERS",
    getSpecificPlayer: "GET_SPECIFIC_PLAYER",
    resetSpecificPlayer: "RESET_SPECIFIC_PLAYER"
};



export async function getPlayerByHomeUser(token) {
    let url = `${Constants.BACKEND_URL}/get-player-by-home-user`;
    return httpGet(url, {}, token);
}


export async function getPersonnelPlayers(personnelID, token){
    let url = `${Constants.BACKEND_URL}/get-personnel-players/` + personnelID;
    return httpGet(url, {}, token);
}

export async function getOnePlayer(playerID, token) {
    let url = `${Constants.BACKEND_URL}/get-one-player/` + playerID;
    return httpGet(url, {}, token);
}

export async function getPlayerHomeUser(playerID, token) {
    let url = `${Constants.BACKEND_URL}/get-player-home-user/` + playerID;
    return httpGet(url, {}, token);
}

export async function getPlayerTeamMembers(playerID, token) {
    let url = `${Constants.BACKEND_URL}/get-player-team-members/` + playerID;
    return httpGet(url, {}, token);
}

export async function sharePlayer(playerID, teamMemberID, token) {
    let config = {
        params: {
            team_member_id: teamMemberID,
            player_id: playerID            
        }
    };
    let url = `${Constants.BACKEND_URL}/share-player`;
    return httpPost(url, config, token);
}

export async function searchOutOfGymPlayers(query, page, token) {
    let url =  `${Constants.BACKEND_URL}/search-out-of-gym-players/${query}/${page}`;
    return httpGet(url, {}, token);
}

export async function cancelPlayerShare(playerID, teamMemberID, token) {
    let config = {
        params: {
            team_member_id: teamMemberID,
            player_id: playerID            
        }
    };
    let url = `${Constants.BACKEND_URL}/cancel-player-share`;
    return httpPost(url, config, token);
}

export async function unarchivePlayer(playerID, token) {
    let config = {
        params: {
            player_id: playerID            
        }
    };
    let url = `${Constants.BACKEND_URL}/unarchive-player`;
    return httpPost(url, config, token);
}

export async function archivePlayer(playerID, fullArchive, token) {
    let config = {
        params: {
            player_id: playerID,
            full_archive: fullArchive        
        }
    };
    let url = `${Constants.BACKEND_URL}/archive-player`;
    return httpPost(url, config, token);
}

export async function getArchivedPlayers(token) {
    let url = `${Constants.BACKEND_URL}/get-archived-players`;
    return httpGet(url, {}, token);
}

export async function getAssignedArchivedPlayers(token) {
    let url = `${Constants.BACKEND_URL}/get-assigned-archived-players`;
    return httpGet(url, {}, token);
}

export function getAssignedPlayers(token) {
  return dispatch => {
      let url = `${Constants.BACKEND_URL}/assigned-players`;
      httpGet(url, {}, token).then((response) => {
          if (response.data.success) {
              dispatch({
                  type: actions.assignedPlayers,
                  assigned_players: response.data.assigned_players
              })
          }
          else {
              //TODO: handle results load error
          }

      })
  }
}

export function resetSpecificPlayer() {
    return {type: actions.resetSpecificPlayer}
}

export function getSpecificPlayer(playerID, token) {
  return dispatch => {
      let url = `${Constants.BACKEND_URL}/get-player/` + playerID;
      httpGet(url, {}, token).then((response) => {
          if (response.data.success) {
              dispatch({
                  type: actions.getSpecificPlayer,
                  specific_player: response.data.player
              })
          }
          else {
              //TODO: handle results load error
          }

      })
  }
}
export function getMyPlayers(token) {
  return dispatch => {
      let url = `${Constants.BACKEND_URL}/get-my-players`;
      httpGet(url, {}, token).then((response) => {
          if (response.data.success) {
              dispatch({
                  type: actions.getMyPlayers,
                  players_data: response.data.players_data
              })
          }
          else {
              //TODO: handle results load error
          }
      })
  }
}

export function resetPlayerState() {
    return {type: actions.resetPlayerState}
}

export function createPlayer(playerObject) {
    return player.create(actions.createPlayer, playerObject, []);
}

export function updatePlayer(playerId, playerObject) {
    return player.update(actions.updatePlayer, playerId, playerObject, []);
}

export function getPlayers(query, sort) {
    return player.list(actions.listPlayer, query, sort);
}

export function getPlayer(playerId) {
    return player.get(actions.getPlayer, playerId, []);
}

const INITIAL_STATE = {
    players: [],
    player: {},
    assigned_players: [],
    retrieved_players: false,
    retrieved_assigned_players: false
};

export default function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actions.resetPlayerState:
            return {
                ...INITIAL_STATE
            };
        case actions.createPlayer:
            return {
                ...state,
                players: action.body ? [...state.players, action.body] : state.players
            };
        case actions.listPlayer:
            return {
                ...state,
                players: action.body ? action.body._items : state.players
            };
        case actions.getPlayer:
            return {
                ...state,
                player: action.body ? action.body : state.player
            };
        case actions.updatePlayer:
            return {
                ...state,
                id: action.body ? action.body : null
            };
        case actions.assignedPlayers:
            return {
                ...state,
                assigned_players: action.assigned_players ? action.assigned_players : state.assigned_players,
                retrieved_assigned_players: true
            }
        case actions.getMyPlayers:
            return {
                ...state,
                owned_players: action.players_data ? action.players_data : state.players,
                retrieved_players: true
            }
        case actions.getSpecificPlayer:
            return {
                ...state,
                specific_player: action.specific_player
            }
        case actions.resetSpecificPlayer:
            return {
                ...state,
                specific_player: false
            }
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/modules/player.js